import { getKey, ProviderError } from './shared';
import { t } from '../modules/i18n';

export async function callAnthropic(model, prompt, signal, opts) {
  const key = getKey("anthropic");
  if (!key) throw new Error(t("err.nokey", { provider: "Anthropic" }));
  const maxOut = (opts && opts.maxOutTokens) || 8192;
  // Build the content array. With no attachments, just send the prompt
  // string (Anthropic accepts both shapes). With images / PDFs, switch
  // to the content-blocks form so we can interleave parts.
  const parts = (opts && opts.parts) || [];
  let content;
  if (parts.length === 0) {
    content = prompt;
  } else {
    content = [];
    for (const a of parts) {
      if (a.kind === 'image' && a.base64) {
        // Anthropic vision: { type: image, source: { type: base64, media_type, data } }
        content.push({
          type: 'image',
          source: { type: 'base64', media_type: a.mime || 'image/png', data: a.base64 },
        });
      } else if (a.kind === 'pdf' && a.base64) {
        // Anthropic native PDF (vision-PDF GA): { type: document, source: { type: base64, ... } }
        content.push({
          type: 'document',
          source: { type: 'base64', media_type: 'application/pdf', data: a.base64 },
        });
      }
    }
    // Prompt goes LAST so the model has the visuals/docs as context before
    // reading the instruction.
    content.push({ type: 'text', text: prompt });
  }
  const r = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": key,
      "anthropic-version": "2023-06-01",
      "anthropic-dangerous-direct-browser-access": "true",
    },
    body: JSON.stringify({
      model, max_tokens: maxOut,
      messages: [{ role: "user", content }],
    }),
    signal,
  });
  if (!r.ok) {
    const err = await r.text();
    throw new ProviderError("Anthropic", r.status, err);
  }
  const data = await r.json();
  const u = data.usage || {};
  // Anthropic returns stop_reason on the message: end_turn | max_tokens | stop_sequence | tool_use
  const stopReason = data.stop_reason || "";
  return {
    text: (data.content || []).map(c => c.text || "").join(""),
    inTokens:  u.input_tokens  || 0,
    outTokens: u.output_tokens || 0,
    finishReason: stopReason,
    truncated: stopReason === "max_tokens",
  };
}
